export type ProductTourStepId =
  | "welcome"
  | "competencies"
  | "skills"
  | "tasks"
  | "progress"
  | "mentor"
  | "chat";

export type ProductTourView = "week" | "route";

export interface ProductTourStep {
  id: ProductTourStepId;
  /** Existing `data-control-id` to spotlight; null centres the tip. */
  targetControlId: string | null;
  /** Dashboard focus or full-route view when on `/me`. */
  preferredView: ProductTourView | null;
  /** Absolute path the tour should open for this step. */
  preferredPath: string;
}

const skillPath = "/me?competency=inhoudelijk&skill=kennisVak";

export const PRODUCT_TOUR_STEPS: readonly ProductTourStep[] = [
  { id: "welcome", targetControlId: null, preferredView: null, preferredPath: "/me?overview=1" },
  {
    id: "competencies",
    targetControlId: "starting-teacher.competencies",
    preferredView: null,
    preferredPath: "/me?overview=1",
  },
  {
    id: "skills",
    targetControlId: "starting-teacher.skills",
    preferredView: null,
    preferredPath: "/me?competency=inhoudelijk",
  },
  {
    id: "tasks",
    targetControlId: "starting-teacher.actions",
    preferredView: null,
    preferredPath: skillPath,
  },
  {
    id: "progress",
    targetControlId: "starting-teacher.progress",
    preferredView: null,
    preferredPath: skillPath,
  },
  {
    id: "mentor",
    targetControlId: "starting-teacher.mentor",
    preferredView: null,
    preferredPath: "/me?overview=1",
  },
  {
    id: "chat",
    targetControlId: "nav.chat",
    preferredView: null,
    preferredPath: "/me/chat",
  },
];
